import { useState } from "react";

export default function CampaignScheduleSelector({
  scheduledAt,
  setScheduledAt
}) {

  const [isScheduled, setIsScheduled] = useState(false);

  return (
    <div style={{position:"relative",zIndex:99999}}>
      <h4>Send Time</h4>

      <label>
        <input
          type="checkbox"
          checked={isScheduled}
          onChange={() => setIsScheduled(!isScheduled)}
        />
        Schedule for later
      </label>

      {isScheduled && (
        <input
          type="datetime-local"
          onChange={e => setScheduledAt(e.target.value)}
        />
      )}
    </div>
  );
}
